import Itineraries from "../../components/itineraries";

export default Itineraries;